/**
 * Flooded / Blue-Violet-Red-Orange.
 */ var BlueVioletRedOrange = [
    /**
     * Violet Props.
     */ {
        variant: 'violet',
        size: '971',
        rotate: -130,
        blur: 19.3,
        x: '235',
        y: '539'
    },
    /**
     * Blue Props.
     */ {
        variant: 'blue',
        size: '911',
        rotate: 50,
        blur: 21.3,
        x: '-412',
        y: '370'
    },
    /**
     * Red Props.
     */ {
        variant: 'red',
        size: '937',
        rotate: -130,
        blur: 27.2,
        x: '972',
        y: '556'
    },
    /**
     * Orange Props.
     */ {
        variant: 'orange',
        size: '950',
        rotate: -50,
        blur: 24.2,
        x: '882',
        y: '-382'
    }
];

export { BlueVioletRedOrange as default };
//# sourceMappingURL=blue-violet-red-orange.es.js.map
